import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { ReactNode, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useElementSize, useUpdateEffect } from 'usehooks-ts'

const debug = window.document.title === 'TA-Interaktiv Microfrontend'

export const AnnotatedImage = ({
  annotations,
  img,
  source,
  maxWidth = 'unset',
}: {
  annotations?: Annotation[]
  img: string
  source?: string
  maxWidth?: number | string
}) => {
  //   const container = useRef<HTMLDivElement>(null)
  const [{ width, height }, setSize] = useState({ width: 0, height: 0 })
  const [loaded, setLoaded] = useState(false)
  const [container, size] = useElementSize()

  useEffect(() => {
    setSize(size)
  }, [size])

  function absolute(value: { x: number; y: number }) {
    return { x: (value.x / 100) * width, y: (value.y / 100) * height }
  }

  return (
    <>
      <AnnotatedImageRoot ref={container} style={{ maxWidth: maxWidth }}>
        <BGImage
          src={img}
          style={{ maxWidth: maxWidth }}
          onLoad={(e) => {
            let box = (e.target as any).getBoundingClientRect()
            setSize({ width: box.width, height: box.height })
            setLoaded(true)
          }}
        />
        {loaded && (
          <SVGOverlay style={{ maxWidth: maxWidth }}>
            {annotations &&
              annotations.map((anno) => {
                return (
                  <Annotation
                    {...{ ...anno, position: absolute(anno.position) }}
                  />
                )
              })}
          </SVGOverlay>
        )}
      </AnnotatedImageRoot>
      {source && (
        <TextWidth>
          <Source>{source}</Source>
        </TextWidth>
      )}
    </>
  )
}
const Source = styled.div`
  font-size: 12px;
  color: var(--gray-3);
  margin-bottom: 60px;
`
const AnnotatedImageRoot = styled.div.attrs({ className: 'AnnotatedImage' })`
  width: 100%;
  /* max-width: 1365px; */
  display: inline-block;
  position: relative;
  /* min-height: 300px; */
  @media screen and (max-width: 712px) {
    max-width: 100vw;
  }
`

const SVGOverlay = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  /* max-width: 1365px; */
  height: 100%;
  /* min-height: 300px; */
`
const BGImage = styled.img`
  /* max-width: 1365px; */
  width: 100%;

  /* pointer-events: none; */
`

export const Annotation = ({
  content,
  position,
  textOffset = { x: 0, y: 0 },
  lineheight = 15,
  linetextOffset = 5,
  showMarker = false,
  showLine = true,
  marker,
  makerStyle = { fill: 'var(--gray-2)', stroke: 'none' },
  lineStyle = { stroke: 'var(--gray-2)', strokeWidth: 1 },
}: Annotation) => {
  const annoPos =
    textOffset.x === 0
      ? textOffset.y < 0
        ? 'top'
        : 'bottom'
      : textOffset.x < 0
      ? 'left'
      : 'right'

  return (
    <AnnotationRoot transform={`translate(${position.x},${position.y})`}>
      {showLine && <line x2={textOffset.x} y2={textOffset.y} {...lineStyle} />}
      {showMarker && (marker || <circle r={2} {...makerStyle} />)}
      <AnnotationText
        transform={`translate(${
          textOffset.x +
          (annoPos === 'top' || annoPos === 'bottom'
            ? 0
            : annoPos === 'left'
            ? -linetextOffset
            : linetextOffset)
        },${
          textOffset.y +
          (textOffset.y > 0 ? lineheight : -linetextOffset) +
          (annoPos === 'left' || annoPos === 'right' ? lineheight * 0.6 : 0)
        })`}
        textAnchor={
          annoPos === 'top' || annoPos === 'bottom'
            ? 'middle'
            : annoPos === 'left'
            ? 'end'
            : 'start'
        }
      >
        {content && content}
      </AnnotationText>
    </AnnotationRoot>
  )
}

const AnnotationRoot = styled.g`
  /* min-height: 300px; */
  line-height: 0;
`

const AnnotationText = styled.g``
